import classNames from 'classnames';
import React from 'react';

import '@assets/fonts/star-scales.scss';

import styles from './indicatorStar.scss';

interface IndicatorStarProps {
  containerStyles?: string;
  isSelected?: boolean;
}

export default function IndicatorStar(props: IndicatorStarProps) {
  const { containerStyles, isSelected } = props;

  const mainContainerStyles = classNames(
    styles.indicatorStarContainer,
    containerStyles,
    'indicatorStar'
  );

  const starStyles = classNames(styles.star, { [styles.star_isSelected]: isSelected });
  const labelStyles = classNames(styles.label, { [styles.label_isSelected]: isSelected });

  return (
    <div aria-hidden className={mainContainerStyles}>
      <div className={starStyles} />
      <span className={labelStyles}>{'\uE800'}</span>
    </div>
  );
}
